<template>
  <v-layout row>
    <v-flex xs12 sm10 offset-sm1 lg10 offset-lg1>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form
          @submit.prevent="register"
          @keydown="form.onKeydown($event)"
          id="admissions-form"
        >
          <v-card-title primary-title>
            <h3 class="headline mb-0">
              {{ $t("admissions.form.page_title") }}
            </h3>
          </v-card-title>
          <v-card-text>
            <h2 class="font-weight-regular">
              {{ $t("admissions.form.aspirant_info") }}
            </h2>
            <v-layout row wrap>
              <v-flex xs12 lg8 px-1>
                <div>
                  <strong
                    >2. {{ $t("admissions.form.names_lastnames") }}</strong
                  >
                </div>
                <v-layout row wrap>
                  <v-flex xs6 px-1>
                    <text-input
                      :form="form"
                      :label="$t('admissions.form.first_name')"
                      :v-errors="errors"
                      v-model="form.first_name"
                      name="first_name"
                      v-validate="'required|min:1|max:49'"
                    ></text-input>
                  </v-flex>
                  <v-flex xs6 px-1>
                    <text-input
                      :form="form"
                      :label="$t('admissions.form.last_name')"
                      :v-errors="errors"
                      v-model="form.last_name"
                      name="last_name"
                      v-validate="'required|min:1|max:49'"
                    ></text-input>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>3. {{ $t("admissions.form.nuip") }}</strong>
                </div>
                <text-input
                  :form="form"
                  :v-errors="errors"
                  v-model="form.nuip"
                  name="nuip"
                  v-validate="'required|min:1|max:49'"
                ></text-input>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>4. {{ $t("admissions.form.date_of_birth") }}</strong>
                </div>
                <date-picker
                  :form="form"
                  :v-errors="errors"
                  v-model="form.date_of_birth"
                  name="date_of_birth"
                  v-validate="'required'"
                  @input="verifyDateGrade()"
                ></date-picker>
              </v-flex>
              <v-flex xs12 lg4 px-1 v-if="extemporanea">
                <div>
                  <strong>Grado según fecha de nacimiento</strong>
                </div>
                <span v-if="system_grade">{{ system_grade.name }}</span>
                <span v-else>N/A</span>
              </v-flex>
              <v-flex xs12 lg4 px-1 v-if="extemporanea">
                <div>
                  <strong>Grado al cual se va a registrar</strong>
                </div>
                <select-input
                  :form="form"
                  :v-errors="errors"
                  v-model="form.selected_grade"
                  :items="originalGrades"
                  name="selected_grade"
                  v-validate="'required'"
                  @input="alertConcordancyGrades()"
                  :disabled="system_grade == null"
                ></select-input>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>5. {{ $t("admissions.form.gender") }}</strong>
                </div>

                <v-radio-group
                  :form="form"
                  :v-errors="errors"
                  v-model="form.gender"
                  row
                  :disabled="disabled_date"
                  name="gender"
                  v-validate="'required'"
                >
                  <v-radio
                    :label="$t('admissions.form.gender_options.m')"
                    value="m"
                    name="gender"
                    :color="'primary'"
                  ></v-radio>
                  <v-radio
                    :label="$t('admissions.form.gender_options.f')"
                    value="f"
                    name="gender"
                    :color="'primary'"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>{{ $t("admissions.form.rc") }}</strong>
                </div>

                <div class="upload">
                  <ul>
                    <li v-for="file in registro_civil" :key="file.id">
                      <span>{{ file.name }}</span> -
                      <span>{{ file.size }}</span>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        <v-tooltip top>
                          <v-icon
                            small
                            class="mr-2"
                            @click.prevent="$refs.upload.remove(file)"
                            slot="activator"
                          >
                            delete
                          </v-icon>
                          <span>{{
                            $t("extracurriculares.clothes.delete")
                          }}</span>
                        </v-tooltip>
                      </span>
                    </li>
                  </ul>
                  <div class="example-btn">
                    <file-upload
                      class="mb-2 v-btn theme--dark primary"
                      extensions="pdf"
                      accept="application/pdf"
                      input-id="file1"
                      :size="1024 * 1024 * 5"
                      v-model="registro_civil"
                      @input-filter="inputFilter"
                      ref="upload"
                    >
                      <i class="fa fa-plus"></i>
                      {{ $t("admissions.form.select") }}
                    </file-upload>
                    <span style="color: red;" v-if="errors && errors.items.find(item => item.id === '6')">El campo de registro cilvil es obligatorio</span>
                    <span style="color: red;" v-if="errorFilesize1">archivo demasiado grande</span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>6. {{ $t("admissions.form.twin") }}</strong>
                </div>

                <v-radio-group
                  :form="form"
                  :value.sync="form.twin"
                  v-model="form.twin"
                  row
                  :disabled="disabled_date"
                >
                  <v-radio
                    :label="$t('admissions.form.yesno_options.yes')"
                    value="Si"
                    name="twin"
                    :color="'primary'"
                  ></v-radio>
                  <v-radio
                    :label="$t('admissions.form.yesno_options.no')"
                    value="No"
                    name="twin"
                    :color="'primary'"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="form.twin === 'Si'">
              <v-flex xs12 lg4 px-1>
                <text-input
                  :form="form"
                  :label="$t('admissions.form.twin_first_name')"
                  :v-errors="errors"
                  v-model="form.twin_first_name"
                  name="twin_first_name"
                ></text-input>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <text-input
                  :form="form"
                  :label="$t('admissions.form.twin_last_name')"
                  :v-errors="errors"
                  v-model="form.twin_last_name"
                  name="twin_last_name"
                ></text-input>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <text-input
                  :form="form"
                  :label="$t('admissions.form.twin_nuip')"
                  :v-errors="errors"
                  v-model="form.twin_nuip"
                  name="twin_nuip"
                ></text-input>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>{{ $t("admissions.form.twin_gender") }}</strong>
                </div>

                <v-radio-group v-model="form.twin_gender" row>
                  <v-radio
                    :label="$t('admissions.form.gender_options.m')"
                    value="m"
                    name="twin_gender"
                    :color="'primary'"
                  ></v-radio>
                  <v-radio
                    :label="$t('admissions.form.gender_options.f')"
                    value="f"
                    name="twin_gender"
                    :color="'primary'"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 lg4 px-1>
                <div>
                  <strong>{{ $t("admissions.form.twin_rc") }}</strong>
                </div>

                <div class="upload2">
                  <ul>
                    <li v-for="file2 in registro_civil_twin" :key="file2.id">
                      <span>{{ file2.name }}</span> -
                      <span>{{ file2.size }}</span>
                      &nbsp;&nbsp;&nbsp;
                      <span>
                        <v-tooltip top>
                          <v-icon
                            small
                            class="mr-2"
                            @click.prevent="$refs.upload2.remove(file2)"
                            slot="activator"
                          >
                            delete
                          </v-icon>
                          <span>{{
                            $t("extracurriculares.clothes.delete")
                          }}</span>
                        </v-tooltip>
                      </span>
                    </li>
                  </ul>
                  <div class="example-btn">
                    <file-upload
                      class="mb-2 v-btn theme--dark primary"
                      extensions="pdf"
                      accept="application/pdf"
                      input-id="file2"
                      :size="1024 * 1024 * 5"
                      v-model="registro_civil_twin"
                      @input-filter="inputFilter"
                      ref="upload2"
                    >
                      <i class="fa fa-plus"></i>
                      {{ $t("admissions.form.select") }}
                    </file-upload>
                    <span style="color: red;" v-if="errorFilesize1">archivo demasiado grande</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>

            <div
              class="pa-4"
              style="background:#F3F3F3; margin:0 -16px; border-top: 4px solid #333;"
            >
              <h2 class="font-weight-regular">
                {{ $t("admissions.form.guardian1_info") }}
              </h2>
              <v-layout row wrap mt-2>
                <v-flex xs12 lg6>
                  <div>
                    <strong
                      >7.
                      {{
                        $t("admissions.form.names_lastnames_guardian1")
                      }}</strong
                    >
                  </div>
                  <v-layout row wrap>
                    <v-flex xs6 px-1>
                      <text-input
                        :form="form"
                        :disabled="disabled_date"
                        :label="$t('admissions.form.guardian1_first_name')"
                        :v-errors="errors"
                        v-model="form.guardian1_first_name"
                        name="guardian1_first_name"
                        v-validate="'required|min:1|max:49'"
                      ></text-input>
                    </v-flex>
                    <v-flex xs6 px-1>
                      <text-input
                        :form="form"
                        :disabled="disabled_date"
                        :label="$t('admissions.form.guardian1_last_name')"
                        :v-errors="errors"
                        v-model="form.guardian1_last_name"
                        name="guardian1_last_name"
                        v-validate="'required|min:1|max:49'"
                      ></text-input>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong>8. {{ $t("admissions.form.guardian1_id") }}</strong>
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_id"
                    name="guardian1_id"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >9.
                      {{ $t("admissions.form.guardian1_cellphone") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_cellphone"
                    name="guardian1_cellphone"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >10. {{ $t("admissions.form.guardian1_email") }}</strong
                    >
                  </div>
                  <email-input
                    :form="form"
                    :disabled="disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_email"
                    name="guardian1_email"
                    v-validate="'required|email|min:1|max:49'"
                  ></email-input>
                  <div style="text-align: center; margin:-20px 0 6px 0;">
                    <v-btn
                      color="primary"
                      dark
                      small
                      @click="verifyEmail(form.guardian1_email, 'guardian1')"
                      >{{ $t("admissions.form.verify") }}</v-btn
                    >
                  </div>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >11.
                      {{ $t("admissions.form.guardian1_relation") }}</strong
                    >
                  </div>
                  <select-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :items="kinship_options"
                    :v-errors="errors"
                    :value.sync="form.guardian1_relation"
                    name="guardian1_relation"
                    v-model="form.guardian1_relation"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >12.
                      {{ $t("admissions.form.guardian1_profession") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_profession"
                    name="guardian1_profession"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >13.
                      {{ $t("admissions.form.guardian1_ocupation") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_ocupation"
                    name="guardian1_ocupation"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >14. {{ $t("admissions.form.guardian1_company") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_company"
                    name="guardian1_company"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >15.
                      {{ $t("admissions.form.guardian1_graduate") }}</strong
                    >
                  </div>

                  <v-radio-group
                    :disabled="disabled1 || disabled_date"
                    v-model="form.guardian1_graduate"
                    row
                  >
                    <v-radio
                      :label="$t('admissions.form.yesno_options.yes')"
                      value="Si"
                      name="guardian1_graduate"
                      :color="'primary'"
                    ></v-radio>
                    <v-radio
                      :label="$t('admissions.form.yesno_options.no')"
                      value="No"
                      name="guardian1_graduate"
                      :color="'primary'"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 lg3 px-1 v-if="form.guardian1_graduate === 'Si'">
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian1_date"
                    :label="$t('admissions.form.guardian1_date')"
                    name="guardian1_date"
                    type="number"
                    v-validate="'required|min:4|max:4'"
                  ></text-input>
                </v-flex>
              </v-layout>
            </div>
            <div
              class="pa-4"
              style="margin:0 -16px; border-top: 4px solid #333;"
            >
              <h2 class="font-weight-regular">
                {{ $t("admissions.form.guardian2_info") }}
              </h2>
              <v-layout row wrap mt-3>
                <v-flex xs12 lg6 px-1>
                  <div>
                    <strong
                      >16.
                      {{
                        $t("admissions.form.names_lastnames_guardian2")
                      }}</strong
                    >
                  </div>
                  <v-layout row wrap>
                    <v-flex xs6 px-1>
                      <text-input
                        :form="form"
                        :disabled="disabled1 || disabled_date"
                        :label="$t('admissions.form.guardian2_first_name')"
                        :v-errors="errors"
                        v-model="form.guardian2_first_name"
                        name="guardian2_first_name"
                        v-validate="'required|min:1|max:49'"
                      ></text-input>
                    </v-flex>
                    <v-flex xs6 px-1>
                      <text-input
                        :form="form"
                        :disabled="disabled1 || disabled_date"
                        :label="$t('admissions.form.guardian2_last_name')"
                        :v-errors="errors"
                        v-model="form.guardian2_last_name"
                        name="guardian2_last_name"
                        v-validate="'required|min:1|max:49'"
                      ></text-input>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >17. {{ $t("admissions.form.guardian2_id") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_id"
                    name="guardian2_id"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >18.
                      {{ $t("admissions.form.guardian2_cellphone") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_cellphone"
                    name="guardian2_cellphone"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout row wrap mt-2>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >19. {{ $t("admissions.form.guardian2_email") }}</strong
                    >
                  </div>
                  <email-input
                    :form="form"
                    :disabled="disabled1 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_email"
                    name="guardian2_email"
                    v-validate="'required|email|min:1|max:49'"
                  ></email-input>
                  <div style="text-align: center; margin:-20px 0 6px 0;">
                    <v-btn
                      color="primary"
                      dark
                      small
                      @click="verifyEmail(form.guardian2_email, 'guardian2')"
                      >{{ $t("admissions.form.verify") }}</v-btn
                    >
                  </div>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >20.
                      {{ $t("admissions.form.guardian2_relation") }}</strong
                    >
                  </div>
                  <select-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :items="kinship_options"
                    :v-errors="errors"
                    :value.sync="form.guardian2_relation"
                    name="guardian2_relation"
                    v-model="form.guardian2_relation"
                    v-validate="'required'"
                  ></select-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >21.
                      {{ $t("admissions.form.guardian2_profession") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_profession"
                    name="guardian2_profession"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >22.
                      {{ $t("admissions.form.guardian2_ocupation") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_ocupation"
                    name="guardian2_ocupation"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout row wrap mt-2>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >23. {{ $t("admissions.form.guardian2_company") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_company"
                    name="guardian2_company"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >24.
                      {{ $t("admissions.form.guardian2_graduate") }}</strong
                    >
                  </div>

                  <v-radio-group
                    :disabled="disabled2 || disabled_date"
                    v-model="form.guardian2_graduate"
                    row
                  >
                    <v-radio
                      :label="$t('admissions.form.yesno_options.yes')"
                      value="Si"
                      name="guardian2_graduate"
                      :color="'primary'"
                    ></v-radio>
                    <v-radio
                      :label="$t('admissions.form.yesno_options.no')"
                      value="No"
                      name="guardian2_graduate"
                      :color="'primary'"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 lg3 px-1 v-if="form.guardian2_graduate === 'Si'">
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.guardian2_date"
                    :label="$t('admissions.form.guardian2_date')"
                    name="guardian2_date"
                    type="number"
                    v-validate="'required|min:4|max:4'"
                  ></text-input>
                </v-flex>
              </v-layout>
            </div>
            <div
              class="pa-4"
              style="background:#F3F3F3; margin:0 -16px; border-top: 4px solid #333;"
            >
              <v-layout row wrap mt-3>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong
                      >25. {{ $t("admissions.form.first_language") }}</strong
                    >
                  </div>
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.first_language"
                    name="first_language"
                    v-validate="'required|min:1|max:49'"
                  ></text-input>
                </v-flex>
                <v-flex xs12 lg3 px-1>
                  <div>
                    <strong>26. {{ $t("admissions.form.wait_list") }}</strong>
                  </div>

                  <v-radio-group
                    :disabled="disabled2 || disabled_date"
                    v-model="form.wait_list"
                    row
                  >
                    <v-radio
                      :label="$t('admissions.form.yesno_options.yes')"
                      value="Si"
                      name="wait_list"
                      :color="'primary'"
                    ></v-radio>
                    <v-radio
                      :label="$t('admissions.form.yesno_options.no')"
                      value="No"
                      name="wait_list"
                      :color="'primary'"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 lg3 px-1 v-if="form.wait_list === 'Si'">
                  <text-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :v-errors="errors"
                    v-model="form.wait_list_name"
                    :label="$t('admissions.form.wait_list_name')"
                    name="wait_list_name"
                  ></text-input>
                </v-flex>
              </v-layout>
              <v-layout row wrap mt-2>
                <v-flex xs12 lg4 px-1>
                  <div>
                    <strong
                      >27. {{ $t("admissions.form.previous_process") }}</strong
                    >
                  </div>
                  <select-input
                    :form="form"
                    :disabled="disabled2 || disabled_date"
                    :items="options"
                    :v-errors="errors"
                    :value.sync="form.previous_process"
                    name="previous_process"
                    v-model="form.previous_process"
                  ></select-input>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-4">
            <v-btn
              form="admissions-form"
              :disabled="disabled1 || disabled2 || disabled_date"
              type="submit"
              color="primary"
              >{{ $t("register") }}</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title class="headline success white--text">{{
            $t("register_ok")
          }}</v-card-title>
          <v-card-text>
            {{ $t("register_ok") }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">{{
              $t("extracurriculares.courses.form.cancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogVerifyEmail" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{
              $t("admissions.form.email_verification")
            }}</span>
          </v-card-title>

          <v-card-text>
            <p>{{ $t("admissions.form.verification_text") }}</p>
            <text-input
              :form="formVerification"
              :label="$t('admissions.form.verification_code')"
              :v-errors="errors"
              v-model="formVerification.code"
              name="code"
            ></text-input>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">{{
              $t("admissions.meetings.form.cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" flat @click="confirmVerification()">{{
              $t("admissions.form.verify")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import Form from "vform";
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import FileUpload from "vue-upload-component";

export default {
  name: "register-view",
  components: {
    FileUpload
  },
  metaInfo() {
    return { title: this.$t("register") };
  },

  data() {
    return {
      system_grade: null,
      originalGrades: [],
      grades: [],
      extemporanea: this.$route.params.extemporanea || null,
      token: this.$route.query.token || null,
      appUrl: window.config.appUrl,
      dialog: false,
      dialogVerifyEmail: false,
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 50 || "Max 20 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      form: new Form({
        selected_grade: "",
        system_grade: "",
        vinculada: "Si",
        first_name: "",
        last_name: "",
        nuip: "",
        date_of_birth: "",
        twin: "No",
        twin_first_name: "",
        twin_last_name: "",
        twin_nuip: "",
        twin_gender: "",
        gender: "",
        guardian1_first_name: "",
        guardian1_last_name: "",
        guardian1_id: "",
        guardian1_cellphone: "",
        guardian1_email: "",
        guardian1_relation: "",
        guardian1_profession: "",
        guardian1_ocupation: "",
        guardian1_company: "",
        guardian1_graduate: "No",
        guardian1_date: "",
        guardian2_first_name: "",
        guardian2_last_name: "",
        guardian2_id: "",
        guardian2_cellphone: "",
        guardian2_email: "",
        guardian2_relation: "",
        guardian2_profession: "",
        guardian2_ocupation: "",
        guardian2_company: "",
        guardian2_graduate: "No",
        guardian2_date: "",
        first_language: "",
        wait_list: "No",
        wait_list_name: "",
        previous_process: "No",
        tcs_description: "",
        question: "",
        meeting_id: "",
        payment_responsible: "",
        other_first_name: "",
        other_last_name: "",
        other_cellphone: "",
        other_email: "",
        other_country: "",
        other_state: "",
        other_address: "",
        notes: "",
        family_id: "",
        setting_id: ""
      }),
      formVerification: new Form({
        code: ""
      }),
      eye: true,
      nit_types: [
        { value: "CC", text: "Cedula de ciudadania" },
        { value: "CE", text: "Cedula de extranjeria" }
      ],
      locales: [
        { value: "en", text: "EN" },
        { value: "es", text: "ES" }
      ],
      countries: [],
      states: [],
      cities: [],
      options: [
        { value: "Si", text: this.$t("admissions.form.yesno_options.yes") },
        { value: "No", text: this.$t("admissions.form.yesno_options.no") }
      ],
      kinship_options: [
        {
          value: "Padre",
          text: this.$t("admissions.form.kinship_options.father")
        },
        {
          value: "Madre",
          text: this.$t("admissions.form.kinship_options.mother")
        },
        {
          value: "Abuelo",
          text: this.$t("admissions.form.kinship_options.grandfather")
        },
        {
          value: "Abuela",
          text: this.$t("admissions.form.kinship_options.grandmother")
        },
        {
          value: "Tío",
          text: this.$t("admissions.form.kinship_options.uncle")
        },
        { value: "Tía", text: this.$t("admissions.form.kinship_options.aunt") },
        {
          value: "Hermano",
          text: this.$t("admissions.form.kinship_options.brother")
        },
        {
          value: "Hermana",
          text: this.$t("admissions.form.kinship_options.sister")
        },
        {
          value: "Otro",
          text: this.$t("admissions.form.kinship_options.other")
        }
      ],
      responsible: [
        { value: "Acudiente 1", text: "Acudiente 1" },
        { value: "Acudiente 2", text: "Acudiente 2" },
        { value: "Otro", text: "Otro" }
      ],
      meetings: [],
      settings: [],
      family: [],
      disabled1: true,
      disabled2: true,
      disabled_date: false,
      verification_code: "",
      verification_target: "",
      confirm_code: "",
      registro_civil: [],
      registro_civil_twin: [],
      addressDialog: false
    };
  },

  created() {
    this.form.locale = this.locale;
    this.init();
  },

  computed: {
    ...mapGetters({
      locale: "locale"
    }),
    statesToShow() {
      return this.states.filter(state => state.id_pais === this.form.country);
    },
    citiesToShow() {
      return this.cities.filter(
        city => city.id_departamento === this.form.state
      );
    }
  },

  watch: {
    locale(newValue, oldValue) {
      this.form.locale = newValue;
    }
  },

  methods: {
    alertConcordancyGrades() {
      if (this.form.selected_grade != this.system_grade.id) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text:
            "El grado seleccionado no coincide con el grado basado en la fecha nacimiento del estudiante, ¿desea continuar de todos modos?",
          modal: true
        });
      }
    },
    changeToken() {
      axios
        .post("/api/admissions/chageTokenExtemporaneous", {
          token: this.token
        }) // Send the token in the request body
        .then(resp => {
          if (resp.status === 200) {
            console.log("change token is successful")
          }
        })
        .catch(error => console.log(error));
    },
    async getGrades() {
      let grades = await axios.get("/api/admissions/grades");
      this.grades = grades.data;
    },
    async getOriginalGrades() {
      let originalGrades = await axios.get("/api/admissions/originalGrades");
      this.originalGrades = originalGrades.data.map(item => ({
        value: item.id,
        text: item.name
      }));
    },
    init() {
      if (this.extemporanea) {
        this.getGrades();
        this.getOriginalGrades();
        console.log(this.grades.grades);
      }
      if (this.token) {
        console.log(this.token);
      }
      axios
        .get("/api/admissions/cohort")
        .then(resp => {
          if (resp.status === 200) {
            this.settings = resp.data;
            this.checkStatus();
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/logged_family")
        .then(resp => {
          if (resp.status === 200) {
            this.family = resp.data[0];
            if (resp.data[0].mother_email) {
              this.disabled1 = false;
            }
            if (resp.data[0].father_email) {
              this.disabled2 = false;
            }
            resp.data[0].father_alumni = "No";
            resp.data[0].mother_alumni = "No";
            if (resp.data[0].father_alumni_year) {
              resp.data[0].father_alumni = "Si";
            }
            if (resp.data[0].mother_alumni_year) {
              resp.data[0].mother_alumni = "Si";
            }
            this.form = new Form({
              vinculada: "Si",
              first_name: "",
              last_name: "",
              nuip: "",
              date_of_birth: "",
              twin: "No",
              twin_first_name: "",
              twin_last_name: "",
              twin_nuip: "",
              gender: "",
              guardian1_first_name: resp.data[0].father,
              guardian1_last_name: resp.data[0].father_last_name,
              guardian1_id: resp.data[0].father_id,
              guardian1_cellphone: resp.data[0].father_cell_phone,
              guardian1_email: resp.data[0].father_email,
              guardian1_relation: "",
              guardian1_profession: resp.data[0].father_profession,
              guardian1_ocupation: resp.data[0].father_ocupation,
              guardian1_company: resp.data[0].father_employer,
              guardian1_graduate: resp.data[0].father_alumni,
              guardian1_date: resp.data[0].father_alumni_year,
              guardian2_first_name: resp.data[0].mother,
              guardian2_last_name: resp.data[0].mother_last_name,
              guardian2_id: resp.data[0].mother_id,
              guardian2_cellphone: resp.data[0].mother_cell_phone,
              guardian2_email: resp.data[0].mother_email,
              guardian2_relation: "",
              guardian2_profession: resp.data[0].mother_profession,
              guardian2_ocupation: resp.data[0].mother_ocupation,
              guardian2_company: resp.data[0].mother_employer,
              guardian2_graduate: resp.data[0].mother_alumni,
              guardian2_date: resp.data[0].mother_alumni_year,
              first_language: "",
              wait_list: "No",
              wait_list_name: "",
              previous_process: "No",
              tcs_description: "",
              question: "",
              meeting_id: "",
              payment_responsible: "",
              other_first_name: "",
              other_last_name: "",
              other_cellphone: "",
              other_email: "",
              other_country: "",
              other_state: "",
              other_address: "",
              notes: "",
              family_id: resp.data[0].family_ident,
              setting_id: this.settings[0].id
            });
          }
        })
        .catch(error => console.log(error));

      axios
        .get("/api/admissions/available_meetings")
        .then(resp => {
          if (resp.status === 200) {
            resp.data.forEach(meeting => {
              this.meetings.push({
                value: meeting.id,
                text: meeting.description + " (" + meeting.date + ")"
              });
            });
          }
        })
        .catch(error => console.log(error));
    },
    showAddressDialog() {
      this.addressDialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogVerifyEmail = false;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile.size < 1024 * 1024 * 5) {
        this.errorFilesize1 = false;
      } else {
        this.errorFilesize1 = true;
      }
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    verifyDate() {
      if (
        moment(this.form.date_of_birth).isBefore(this.settings[0].birthdate1)
      ) {
        this.disabled_date = true;
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: this.$t("admissions.form.date_before"),
          modal: true
        });
      } else if (
        moment(this.form.date_of_birth).isAfter(this.settings[0].birthdate2)
      ) {
        this.disabled_date = true;
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: this.$t("admissions.form.date_after"),
          modal: true
        });
      } else {
        this.disabled_date = false;
        return true;
      }
    },
    verifyDateGrade() {
      this.verifyDate();
      if (this.extemporanea) {
        let grades = this.grades;
        grades.forEach(grade => {
          if (
            moment(this.form.date_of_birth).isBetween(
              grade.initial_date_birth,
              grade.final_date_birth
            )
          ) {
            this.system_grade = grade.grade;
            this.form.system_grade = grade.grade.id;
            // console.log("sistema", this.system_grade);
          }
        });
      }
    },
    verifyEmail(email, target) {
      if (email !== "") {
        this.formVerification = new Form({
          code: ""
        });
        const verification_code = Math.floor(1000 + Math.random() * 9000);
        this.dialogVerifyEmail = true;
        axios
          .post("/api/admissions/check_email", { email, verification_code })
          .then(resp => {
            if (resp.status === 200) {
              this.verification_code = verification_code;
              this.verification_target = target;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    confirmVerification() {
      if (this.formVerification.code !== "") {
        if (this.formVerification.code == this.verification_code) {
          this.dialogVerifyEmail = false;
          if (this.verification_target == "guardian1") {
            this.disabled1 = false;
          }
          if (this.verification_target == "guardian2") {
            this.disabled2 = false;
          }
        }
      }
    },
    setAddress() {
      const address = [
        this.address_form.det1,
        this.address_form.det2,
        this.address_form.det3,
        this.address_form.det4,
        this.address_form.det5,
        this.address_form.det6
      ]
        .map(det => det.trim())
        .join(" ");
      this.form.address = address;
      this.addressDialog = false;
    },
    async register() {
      console.log(JSON.stringify(this.errors));
      if (await this.formHasErrors()) return;

      // Register the user.
      this.form
        .post("/api/admissions/register")
        .then(resp => {
          if (resp.data.already_exists) {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "Ya existe un registro con el mismo número de identificación.",
              modal: true
            });
          } else if (resp.data.meeting_quota) {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "La reunión informativa que seleccionó ya se encuentra llena, por favor seleccione otra.",
              modal: true
            });
          } else {
            let formData = new FormData();
            let fileData;
            this.registro_civil.forEach((file, index) => {
              fileData = this.$refs.upload.get(file.id);
              formData.append(`file_${index}`, fileData.file);
            });
            formData.append("entry_id", resp.data.entry_id);
            axios.post("/api/admissions/register/rc", formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            });
            if (resp.data.twin_id) {
              let formData2 = new FormData();
              let fileData2;
              this.registro_civil_twin.forEach((file, index) => {
                fileData2 = this.$refs.upload2.get(file.id);
                formData2.append(`file_${index}`, fileData2.file);
              });
              formData2.append("entry_id", resp.data.twin_id);
              axios.post("/api/admissions/register/rc", formData2, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
            }
            this.$store.dispatch("responseMessage", {
              type: "success",
              text:
              "Ha sido pre registrado con éxito. Más adelante recibirá la invitación para empezar el proceso de admisiones.",
              modal: true
            });
            this.changeToken();
          }
        })
        .catch(err => {
          console.log(err.response);
        });
      
    },
    goToLogin() {
      this.$router.push({ name: "login" });
      this.dialog = false;
    },
    checkStatus() {
      if (this.settings.length < 1) {
        location.href = "https://www.columbus.edu.co";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/register.vue